import { Component, Input, Output, EventEmitter, OnInit, OnChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { LocationDataService } from '../services/location-data.service';

@Component({
  selector: 'lib-state-province-dropdown',
  templateUrl: './state-province-dropdown.component.html',
  styleUrls: ['./state-province-dropdown.component.css']
})
export class StateProvinceDropdownComponent implements OnInit, OnChanges {
  @Input() control!: FormControl;
  @Input() country: string = '';
  @Input() placeholder: string = 'Select State/Province';
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() cssClass: string = '';
  @Input() showValidation: boolean = true;
  @Input() forceInvalid: boolean = false;
  @Input() customValidationClass: string = '';
  @Output() selectionChange = new EventEmitter<string>();

  states: string[] = [];

  constructor(private locationDataService: LocationDataService) {}

  ngOnInit() {
    this.updateStates();
  }

  ngOnChanges() {
    this.updateStates();
  }

  get computedCssClass(): string {
    let classes = this.cssClass || 'form-select';

    if (this.showValidation) {
      // Check for custom validation class first
      if (this.customValidationClass) {
        classes += ` ${this.customValidationClass}`;
      }
      // Check for forced invalid state
      else if (this.forceInvalid) {
        classes += ' is-invalid';
      }
      // Check for control validation state
      else if (this.control && this.control.touched && this.control.invalid) {
        classes += ' is-invalid';
      }
    }

    return classes;
  }

  private updateStates() {
    this.states = this.locationDataService.getStatesByCountry(this.country);
  }

  onSelectionChange(event: any) {
    this.selectionChange.emit(event.target.value);
  }
}
